export default __webpack_public_path__ + "static/media/about-us-img.9e3db8f3.jpg";